import { axiosInstance } from "@/plugins/axios";

export default {
  namespaced: true,
  state: {
    specialties: [],
    targetAudience: [],
    daysOfTheWeek: [],
    statusSchedule: [],
    allProfessionals: [],
    professional: {},
    allSchedules: [],
    detailsSchedule: {},
    methodPayments: [],
    methodPayment: {},
  },
  getters: {
    specialties(state) {
      return state.specialties;
    },
    targetAudience(state) {
      return state.targetAudience;
    },
    daysOfTheWeek(state) {
      return state.daysOfTheWeek;
    },
    statusSchedule(state) {
      return state.statusSchedule;
    },
    allProfessionals(state) {
      return state.allProfessionals;
    },
    professional(state) {
      return state.professional;
    },
    allSchedules(state) {
      return state.allSchedules;
    },
    detailsSchedule(state) {
      return state.detailsSchedule;
    },
    methodPayments(state) {
      return state.methodPayments;
    },
    methodPayment(state) {
      return state.methodPayment;
    },
  },
  mutations: {
    SET_SPECIALTIES(state, value) {
      state.specialties = value;
    },
    SET_TARGET_AUDIENCE(state, value) {
      state.targetAudience = value;
    },
    SET_DAYS_OF_THE_WEEK(state, value) {
      state.daysOfTheWeek = value;
    },
    SET_STATUS_SCHEDULE(state, value) {
      state.statusSchedule = value;
    },
    SET_ALL_PROFESSIONALS(state, value) {
      state.allProfessionals = value;
    },
    SET_PROFESSIONAL(state, value) {
      state.professional = value;
    },
    SET_ALL_SCHEDULES(state, value) {
      state.allSchedules = value;
    },
    SET_DETAILS_SCHEDULE(state, value) {
      state.detailsSchedule = value;
    },
    SET_METHOD_PAYMENTS(state, value) {
      state.methodPayments = value;
    },
    SET_METHOD_PAYMENT(state, value) {
      state.methodPayment = value;
    },
  },
  actions: {
    async registerSpecialties(context, value) {
      const formData = new FormData();
      formData.append("name", value.name);

      const url = value?.id
        ? `professional/specialties/${value.id}`
        : "professional/specialties";

      await axiosInstance({
        method: "POST",
        url: url,
        data: formData,
      })
        .then((response) => response.data)
        .then(() => {
          context.dispatch("consultSpecialties");
        });
    },
    async consultSpecialties(context, value) {
      const url = value?.id
        ? `professional/specialties/${value.id}`
        : "professional/specialties";

      const { data } = await axiosInstance({
        method: "GET",
        url: url,
      });

      if (value?.id) {
        context.dispatch("setDataDefault", ["SET_SPECIALTIES", data]);
        return;
      }
      context.dispatch("setDataDefault", ["SET_SPECIALTIES", data]);
    },
    async registerTargetAudience(context, value) {
      const formData = new FormData();
      formData.append("name", value.name);

      const url = value?.id
        ? `professional/targetAudience/${value.id}`
        : "professional/targetAudience";

      await axiosInstance({
        method: "POST",
        url: url,
        data: formData,
      })
        .then((response) => response.data)
        .then(() => {
          context.dispatch("consultTargetAudience");
        });
    },
    async consultTargetAudience(context, value) {
      const url = value?.id
        ? `professional/targetAudience/${value.id}`
        : "professional/targetAudience";

      const { data } = await axiosInstance({
        method: "GET",
        url: url,
      });

      if (value?.id) {
        context.dispatch("setDataDefault", ["SET_TARGET_AUDIENCE", data]);
        return;
      }

      context.dispatch("setDataDefault", ["SET_TARGET_AUDIENCE", data]);
    },
    async registerDayOfTheWeek(context, value) {
      const formData = new FormData();
      formData.append("name", value.name);

      const url = value?.id
        ? `professional/daysOfTheWeek/${value.id}`
        : "professional/daysOfTheWeek";

      await axiosInstance({
        method: "POST",
        url: url,
        data: formData,
      })
        .then((response) => response.data)
        .then(() => {
          context.dispatch("consultDaysOfTheWeek");
        });
    },
    async consultDaysOfTheWeek(context, value) {
      const url = value?.id
        ? `professional/daysOfTheWeek/${value.id}`
        : "professional/daysOfTheWeek";

      const { data } = await axiosInstance({
        method: "GET",
        url: url,
      });

      if (value?.id) {
        context.dispatch("setDataDefault", ["SET_DAYS_OF_THE_WEEK", data]);
        return;
      }

      context.dispatch("setDataDefault", ["SET_DAYS_OF_THE_WEEK", data]);
    },
    async registerStatusSchedule(context, value) {
      const formData = new FormData();
      formData.append("name", value.name);

      const url = value?.id
        ? `professional/statusSchedule/${value.id}`
        : "professional/statusSchedule";

      await axiosInstance({
        method: "POST",
        url: url,
        data: formData,
      })
        .then((response) => response.data)
        .then(() => {
          context.dispatch("consultStatusSchedule");
        });
    },
    async consultStatusSchedule(context, value) {
      const url = value?.id
        ? `professional/statusSchedule/${value.id}`
        : "professional/statusSchedule";

      const { data } = await axiosInstance({
        method: "GET",
        url: url,
      });

      if (value?.id) {
        context.dispatch("setDataDefault", ["SET_STATUS_SCHEDULE", data]);
        return;
      }

      context.dispatch("setDataDefault", ["SET_STATUS_SCHEDULE", data]);
    },
    async consultProfessionalPendingValidate(context, id) {
      const url = id
        ? `professional/${id}/details`
        : "professional/all-pending-validate";

      const { data } = await axiosInstance({
        method: "GET",
        url: url,
      });

      if (id) {
        context.dispatch("setDataDefault", ["SET_PROFESSIONAL", data]);
        return;
      }

      context.dispatch("setDataDefault", ["SET_ALL_PROFESSIONALS", data]);
    },
    async consultProfessionalSchedules(context, obj) {
      const hasIds = obj?.id && obj?.idSchedule;
      const url = hasIds
        ? `professional/${obj?.id}/schedule/${obj?.idSchedule}`
        : "professional/all-schedules";

      const { data } = await axiosInstance({
        method: "GET",
        url: url,
      });

      if (hasIds) {
        context.dispatch("setDataDefault", ["SET_DETAILS_SCHEDULE", data]);
        return;
      }

      context.dispatch("setDataDefault", ["SET_ALL_SCHEDULES", data]);
    },
    async updateProfessional(context, value) {
      return await axiosInstance({
        method: "POST",
        url: `professional/${value.id}/update`,
        data: value,
      });
    },
    async removeSpecialty(context, id) {
      const { data } = await axiosInstance({
        method: "DELETE",
        url: `professional/specialties/${id}`,
      });

      if (data) {
        context.dispatch("consultSpecialties");
      }
    },
    async removeTargetAudience(context, id) {
      const { data } = await axiosInstance({
        method: "DELETE",
        url: `professional/targetAudience/${id}`,
      });

      if (data) {
        context.dispatch("consultTargetAudience");
      }
    },
    async removeDaysOfTheWeek(context, id) {
      const { data } = await axiosInstance({
        method: "DELETE",
        url: `professional/daysOfTheWeek/${id}`,
      });

      if (data) {
        context.dispatch("consultDaysOfTheWeek");
      }
    },
    async removeStatusSchedule(context, id) {
      const { data } = await axiosInstance({
        method: "DELETE",
        url: `professional/statusSchedule/${id}`,
      });

      if (data) {
        context.dispatch("consultStatusSchedule");
      }
    },
    async editSchedule(context, value) {
      return await axiosInstance({
        method: "POST",
        url: `schedule/${value.id_schedule}/edit`,
        data: { schedule: value },
      });
    },
    async registerMethodPayment(context, value) {
      const formData = new FormData();

      for (const key in value) {
        formData.append(key, value[key]);
      }

      const url = value?.id
        ? `professional/methodPayment/${value.id}`
        : "professional/methodPayment";

      await axiosInstance({
        method: "POST",
        url: url,
        data: formData,
      });

      context.dispatch("consultMethodPayment");
    },
    async consultMethodPayment(context, id) {
      const url = id
        ? `professional/methodPayment/${id}`
        : "professional/methodPayment";

      const { data } = await axiosInstance({
        method: "GET",
        url: url,
      });

      if (id) {
        context.dispatch("setDataDefault", ["SET_METHOD_PAYMENT", data]);
        return;
      }

      context.dispatch("setDataDefault", ["SET_METHOD_PAYMENTS", data]);
    },
    setDataDefault(context, [mutationName, value]) {
      context.commit(`${mutationName}`, value);
    },
  },
};
